<template>
    <div v-if="isLoading" class="loader-overlay">
      <div class="loader-balls">
        <div class="ball delay-1"></div>
        <div class="ball delay-2"></div>
        <div class="ball delay-3"></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "Loader",
    data() {
      return {
        isLoading: true
      };
    },
    mounted() {
      if (document.readyState === "complete") {
        this.isLoading = false;
      } else {
        window.addEventListener("load", this.handleLoad);
      }
    },
    beforeDestroy() {
      window.removeEventListener("load", this.handleLoad);
    },
    methods: {
      handleLoad() {
        this.isLoading = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .loader-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .loader-balls {
    display: flex;
    gap: 10px;
  }
  
  .ball {
    width: 16px;
    height: 16px;
    background-color: #C0392B ;
    border-radius: 50%;
    animation: bounce 0.6s infinite ease-in-out;
  }
  
  .delay-1 {
    animation-delay: -0.3s;
  }
  .delay-2 {
    animation-delay: -0.15s;
  }
  .delay-3 {
    animation-delay: 0s;
  }
  
  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
  </style>
  